import { render } from "./EditUserPage.vue?vue&type=template&id=6511506a&scoped=true&ts=true"
import script from "./EditUserPage.vue?vue&type=script&lang=ts"
export * from "./EditUserPage.vue?vue&type=script&lang=ts"

import "./EditUserPage.vue?vue&type=style&index=0&id=6511506a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6511506a"]])

export default __exports__